<template>
  <div class="record-counter">
    <div class="record-counter__count" v-if="count">{{ count }}</div>
    <div class="record-counter__subtitle" v-if="subtitle">{{ subtitle }}</div>
    <div class="record-counter__description" v-if="description"><span v-html="description"></span></div>
    <m4-separator title="OR" title-bg-light class="margin-b-xl padding-t-md margin-t-md"></m4-separator>
    <m4-button
      class="margin-r-xs margin-l-xs"
      variant="info"
      tag="a"
      size="md"
      left-icon="list"
      :href="infoBtnUrl"
      v-if="infoBtnUrl"
    >
      {{ infoBtnTitle }}
    </m4-button>
    <m4-button
      class="margin-l-xs margin-r-xs"
      variant="primary"
      tag="a"
      size="md"
      left-icon="plus"
      :href="primaryBtnUrl"
      v-if="primaryBtnUrl"
    >
      {{ primaryBtnTitle }}
    </m4-button>
  </div>
</template>

<script>
export default {
  name: "M4RecordCounter",
  props: {
    count: String,
    subtitle: String,
    description: String,
    infoBtnUrl: String,
    infoBtnTitle: String,
    primaryBtnUrl: String,
    primaryBtnTitle: String
  }
};
</script>
